import './modules/jquery';
import 'bootstrap';

import './modules/age-gate';
import './modules/alert';
import './modules/buttons-animated';
import './modules/contact-form';
import './modules/cookie-notice';
import './modules/datalayer';
import './modules/external-links';
import './modules/form-validation';
import './modules/header';
import './modules/mobile-menu';
import './modules/modals';
import './modules/modal-newsletter';
import './modules/sharing-links';
import './modules/shop-buttons';
import './modules/storyteller';
import './modules/table-of-contents';
import './modules/video-modal';

// import './modules/localization-form';
